import React, { useState } from 'react';
import { confirmSignUp } from '@aws-amplify/auth';

function ConfirmSignup() {
  const [username, setUsername] = useState("");
  const [confirmationCode, setConfirmationCode] = useState("");
  const [message, setMessage] = useState("");

  const handleConfirmSignup = async () => {
    try {
      await confirmSignUp({username, confirmationCode});
      setMessage("Account confirmed successfully. You can now sign in.");
      window.location.href = '/signin';
    } catch (error) {
      setMessage("Failed to confirm account");
    }
  };

  return (
    <div>
      <h1>Confirm Signup</h1>
      <input
        type="text"
        placeholder="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <input
        type="text"
        placeholder="Confirmation Code"
        value={confirmationCode}
        onChange={(e) => setConfirmationCode(e.target.value)}
      />
      <button onClick={handleConfirmSignup}>Confirm Signup</button>
      <p>{message}</p>
    </div>
  );
}

export default ConfirmSignup;
